'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.selection = [];
  }

  $onInit() {
    this.getOne();
    this.getList();
  }

  getOne() {
    this.$http.get(`/api/AppConfGroups/${this.$stateParams.id}`).then(res => {
      this.one = res.data;
    });
  }

  save() {
    this.$http.put(`/api/AppConfGroups/${this.$stateParams.id}`, this.one).then(res => {
      this.$state.go('^');
    });
  }

  remove(id) {
    if(confirm("确定？")) {
      this.$http.post(`/api/AppConfGroups/${this.$stateParams.id}/removeModel`, {models: [id]}).then(res => {
        this.getOne();
      });
    }
  }

  toggleSelection(id) {
    let idx = this.selection.indexOf(id);
    if(idx > -1) {
      this.selection.splice(idx, 1);
    } else {
      this.selection.push(id);
    }
  }

  batchRemove() {
    if(confirm("确定？")) {
      this.$http.post(`/api/AppConfGroups/${this.$stateParams.id}/removeModel`, {
        models: this.selection
      }).then(res => {
        this.getOne();
      });
    }
  }

  batchMove(id) {
    if(confirm("确定？")) {
      let params = {
        models: this.selection,
        from: this.$stateParams.id,
        to: id
      };
      this.$http.post(`/api/AppConfGroups/moveModels`, params).then(res => {
        this.getOne();
      });
    }
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.list = res.data;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfgroups/show/show.controller.js